<template>
  <layout-main-inner title="概况统计">
    <overview-data />
    <overview-time-data />
  </layout-main-inner>
</template>

<script>
import OverviewData from '../home/overview-data.vue'
import OverviewTimeData from '../home/overview-time-data.vue'
export default {
  name: 'StatOverview',
  components: {
    OverviewData, OverviewTimeData
  }
}
</script>

<style>

</style>
